import { GET_LIST_CURRENCY_SUCCESS } from '../actions/getListCurrency';

const initState = {
    listCurrency: []
}

export default (state = initState, action) => {
    switch (action.type) {
        case GET_LIST_CURRENCY_SUCCESS:
            return {
                listCurrency: action.payload.data.data
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/getListCurrency.js